<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--sm">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-information-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">

                    <div class="box-body">


                        <div class="grid grid-cols-12  gap-x-6 mt-3">



                            <div class="xl:col-span-12 col-span-12">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">ARTICLE</label>
                                <input disabled type="text" :value="Items.libelle"
                                       class="form-control text-center" style="font-weight: bold !important;">

                            </div>



                            <div class="xl:col-span-6 col-span-12 mt-3 mb-3">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">ENTREPÔT</label>
                                <input :value="entrepot" type="text" disabled  class="form-control text-center" style="font-weight: bold !important;">

                            </div>


                            <div class="xl:col-span-6 col-span-12 mt-3 mb-3">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">STOCK</label>
                                <input :value="stock" type="number" disabled  class="form-control text-center" style="font-weight: bold !important;">

                            </div>





                        </div>




                    </div>
                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>

    <baseconfirmdialog ref="baseconfirmdialog"  ></baseconfirmdialog>

</template>

<script>

    const axios =require('axios');
    import baseconfirmdialog from "@/components/baseconfirmdialog";
    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",
        watch: {

        },

        computed:{

        },
        components: {
            baseconfirmdialog

        },

        data() {
            return {
                isdisplay:false,
                datavalue:"",
                titlemodal:"",
                Items:{},
                entrepot:"",
                stock:0
                   };
        },
        methods: {


            selected(selectprix){



                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { item: this.Items,newqte:this.newqte,
                    oldqte:this.oldqte,
                    isNormalisationEtat:this.isNormalisationEtat};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('updateqteitem', elementSelectionne);


                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },


            close(){

                this.isdisplay=false;


            },


            async loadItemsdetail(Items){

                const t = this;
                t.$store.dispatch('lancerchargement',true)
                let url=`${process.env.VUE_APP_API_URL}/egl745874pstock771714dfe/ar/${Items.pid}/${Items.mg}/majstck/${this.$store.state.appsociete}/${randomString()}`;
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)

                        if(res.data.success){

                            t.stock=res.data.m.stck;
                            t.entrepot=res.data.m.entp;
                            t.isdisplay=true;
                        }else{

                            t.$refs.baseconfirmdialog.showConfirm({
                                title: 'Alerte',
                                html: "<span style='color: red; font-weight: bold;'>Aucune donnée n'est disponible pour le moment. Veuillez réessayer ultérieurement.</span>",
                                icon: 'warning',
                                confirmButtonText: 'OK',
                                showCancelButton: false,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                reverseButtons: true,
                                customClass: {
                                    confirmButton: 'swal-confirm-red'
                                },
                                onConfirm: () => {
                                    console.log('Action onConfirm.')
                                },
                                onCancel: () => {
                                    console.log('Action annulée.')
                                }
                            })

                        }

                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })













            },


            show(Items){

                this.Items=Items
                this.titlemodal=`Détail de l'article << ${Items.libelle} >>.`

                this.loadItemsdetail(Items);

            },


        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--sm { max-width:460px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    @media screen and (max-width: 768px) {

        .cf-dialog--sm { max-width:100%; }


    }

</style>